import BricksError from './BricksError';
class InvalidInvestorId extends BricksError {
    constructor(options) {
        super('The provided investor id is invalid', options);
    }
}
export default InvalidInvestorId;
